<template>
<svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.499993 18.5L7.90903 11.0909C8.78403 10.2159 8.78403 8.7841 7.90903 7.9091L0.499993 0.5" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {
  name: 'IconArrowLeft'
}
</script>
